import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ApiErrorAlertComponent } from './api-error-alert.component';

/**
 * Shows the generic "request failed" alert for the admin panel. A burst of failing requests
 * (e.g. a page loading several lists while the API is down) produces a single alert, not one per
 * request. A page that opens its own, more specific snackbar simply replaces this one.
 */
@Injectable({ providedIn: 'root' })
export class ApiErrorAlertService {
  private readonly snackBar = inject(MatSnackBar);
  private openAlert: MatSnackBarRef<ApiErrorAlertComponent> | null = null;

  showError(): void {
    if (this.openAlert) {
      return;
    }

    const alert = this.snackBar.openFromComponent(ApiErrorAlertComponent, {
      panelClass: 'api-error-alert-panel',
      politeness: 'assertive',
    });
    this.openAlert = alert;
    alert.afterDismissed().subscribe(() => {
      if (this.openAlert === alert) {
        this.openAlert = null;
      }
    });
  }
}
